
export function buildEncodedFormData(data) {
    return buildFormData(data).join('&');
}

export function buildFormData(data) {
    var form = [];
    //special handling for object/array data, arrays will use "model" as the container ns
    //addItemsToForm(form, typeof data == 'object' ? [] : [options.name || 'model'], data);
    addItemsToForm(form, [], data);
    return form;
}

//https://github.com/matthew-andrews/isomorphic-fetch/issues/30
export function addItemsToForm(form, names, obj) {
    if(obj === undefined || obj === "" || obj === null) {
        return addItemToForm(form, names, "");
    }

    /* eslint-disable eqeqeq */

    if(
        typeof obj == "string"
        || typeof obj == "number"
        || obj === true
        || obj === false
    ) {
        return addItemToForm(form, names, obj);
    }

    if(obj instanceof Date) {
        return addItemToForm(form, names, obj.toJSON());
    }

    // array or otherwise array-like
    if(obj instanceof Array) {
        return obj.forEach((v, i) => {
            names.push(`[${i}]`);
            addItemsToForm(form, names, v);
            names.pop();
        });
    }

    if(typeof obj === "object") {
        return Object.keys(obj).forEach((k)=> {
            names.push(k);
            addItemsToForm(form, names, obj[k]);
            names.pop();
        });
    }
}

export function addItemToForm(form, names, value) {
    var name = encodeURIComponent(names.join('.').replace(/\.\[/g, '['));
    value    = encodeURIComponent(value.toString());
    form.push(`${name}=${value}`);
}



// WEBPACK FOOTER //
// ./src/Utils/formUtils.js


// WEBPACK FOOTER //
// webpack:///src/Utils/formUtils.js